

import './Contact.css';

function Contact() {
  return (
    <div className="contact-page">

      <section className="contact-hero">
        <h1>Contact CarbCareUSA</h1>
        <p>
          Questions about carburetors, rebuild kits, or marine systems? Our team
          is here to help you find the right solution for your engine.
        </p>
      </section>

      <section className="contact-container">

        <div className="contact-info">
          <h2>Get In Touch</h2>

          <div className="contact-item">
            <strong>Email</strong>
            <span>support@carbcareusa.com</span>
          </div>

          <div className="contact-item">
            <strong>Phone</strong>
            <span>(619) 555‑0199</span>
          </div>

          <div className="contact-item">
            <strong>Hours</strong>
            <span>Monday – Friday | 9AM – 5PM</span>
          </div>

        </div>

        <form className="contact-form">

          <h2>Send Us A Message</h2>

          <input
            type="text"
            placeholder="Your Name"
            required
          />

          <input
            type="email"
            placeholder="Email Address"
            required
          />

          <input
            type="text"
            placeholder="Subject"
          />

          <textarea
            placeholder="How can we help you?"
            rows="6"
            required
          />

          <button type="submit" className="contact-button">
            Send Message
          </button>

        </form>

      </section>

    </div>
  );
}

export default Contact;